import { Component } from '@theme/component';
import { swapPanels, expandContainer } from '@theme/tab-panels';

class CollectionTabsComponent extends Component {
  refs = {
    tab: [],
    panel: [],
    productList: [],
    viewAllBtn: [],
  };

  connectedCallback() {
    super.connectedCallback();
    this.initialCount = parseInt(this.dataset.initialCount) || 6;
    this.expandCount = parseInt(this.dataset.expandCount) || 6;
    this.activeIndex = 0;
    this.loadedCounts = [];

    // Mobile: fold to 3 products initially, the rest behind the view-all button
    if (window.matchMedia('(max-width: 600px)').matches) {
      this.initialCount = Math.min(this.initialCount, 3);
    }

    this._panelContainer = this.querySelector('.cts-content');

    this._initPanels();
  }

  _initPanels() {
    const panels = this.refs.panel || [];
    panels.forEach((panel, index) => {
      const productList = this.refs.productList?.[index];
      if (!productList) return;

      const allCards = productList.querySelectorAll('.cts-card');
      this.loadedCounts[index] = this.initialCount;

      allCards.forEach((card, cardIndex) => {
        if (cardIndex >= this.initialCount) {
          card.classList.add('is-hidden');
        }
      });

      this._updateViewAllButton(index);
    });
  }

  switchTab(event, data) {
    const index = data.index;
    if (index === this.activeIndex) return;

    const tabs = this.refs.tab || [];
    const panels = this.refs.panel || [];

    if (tabs[this.activeIndex]) {
      tabs[this.activeIndex].classList.remove('is-active');
    }
    if (tabs[index]) {
      tabs[index].classList.add('is-active');
    }

    const oldPanel = panels[this.activeIndex];
    const newPanel = panels[index];

    if (this._panelContainer && oldPanel && newPanel) {
      swapPanels({ container: this._panelContainer, oldPanel, newPanel });
    } else {
      if (oldPanel) oldPanel.setAttribute('hidden', '');
      if (newPanel) newPanel.removeAttribute('hidden');
    }

    this.activeIndex = index;
  }

  loadMore(event, data) {
    const index = data.panelIndex;
    const productList = this.refs.productList?.[index];
    if (!productList) return;

    const allCards = productList.querySelectorAll('.cts-card');
    const currentCount = this.loadedCounts[index] || this.initialCount;
    const newCount = Math.min(currentCount + this.expandCount, allCards.length);

    // Height must be measured BEFORE the cards are revealed.
    const container = this._panelContainer;
    const fromHeight = container ? container.offsetHeight : null;

    for (let i = currentCount; i < newCount; i++) {
      allCards[i].classList.remove('is-hidden');
    }

    this.loadedCounts[index] = newCount;
    this._updateViewAllButton(index);

    if (container) {
      expandContainer(container, fromHeight, this.refs.panel?.[index]);
    }
  }

  _updateViewAllButton(index) {
    const btn = this.refs.viewAllBtn?.[index];
    if (!btn) return;

    const productList = this.refs.productList?.[index];
    if (!productList) return;

    const allCards = productList.querySelectorAll('.cts-card');
    const currentCount = this.loadedCounts[index] || this.initialCount;

    if (currentCount >= allCards.length) {
      btn.style.display = 'none';
    }
  }
}

if (!customElements.get('collection-tabs-component')) {
  customElements.define('collection-tabs-component', CollectionTabsComponent);
}
